import CryptoJS from 'crypto-js'
// 默认的 KEY
const KEY = CryptoJS.enc.Utf8.parse('uateP9a4jm7okKCw')
/**
* AES加密 ：字符串 key
*/
export function Encrypt (word, keyStr) {
  let key = KEY
  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr)
  }
  const srcs = CryptoJS.enc.Utf8.parse(JSON.stringify(word))
  const encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
  return encrypted.toString()
}

export function adScorll () {
  var speed = 30 // 速度数值越大速度越慢
  // eslint-disable-next-line camelcase
  var colee_left2 = document.getElementById('colee_left2')
  // eslint-disable-next-line camelcase
  var colee_left1 = document.getElementById('colee_left1')
  // eslint-disable-next-line camelcase
  var colee_left = document.getElementById('colee_left')
  colee_left2.innerHTML = colee_left1.innerHTML
  function Marquee3 () {
    if (colee_left2.offsetWidth - colee_left.scrollLeft <= 0) { // offsetWidth 是对象的可见宽度
      colee_left.scrollLeft -= colee_left1.offsetWidth // scrollWidth 是对象的实际内容的宽，不包边线宽度
    } else {
      colee_left.scrollLeft++
    }
  }
  var MyMar3 = setInterval(Marquee3, speed)
  colee_left.onmouseover = function () {
    clearInterval(MyMar3)
  }
  colee_left.onmouseout = function () {
    MyMar3 = setInterval(Marquee3, speed)
  }
}
// 拨打电话方法
export function callTel (src) {
  const srcStr = `tel:${src}`
  const link = document.createElement('a')
  link.setAttribute('href', srcStr)
  const evt = document.createEvent('MouseEvents')
  evt.initMouseEvent('click', true, true)
  link.dispatchEvent(evt)
}
